export default __webpack_public_path__ + "static/media/5.42c6e42a.png";